import { render, staticRenderFns } from "./ProsesOrder.vue?vue&type=template&id=2f474374&"
import script from "./ProsesOrder.vue?vue&type=script&lang=js&"
export * from "./ProsesOrder.vue?vue&type=script&lang=js&"
import style0 from "./ProsesOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports